import { openURL } from './browser.utils';
import { filterXSS } from 'xss';

export const redirectOnLeave = (isRejoin: boolean) => {
  const url = isRejoin ? '/end' : '/rejoin';
  openURL(url);
};

export const getUUID = () => {
  const uuid4 = (1e7 + -1e3 + -4e3 + -8e3 + -1e11)
    .toString()
    .replace(/[018]/g, (c: string) =>
      (parseInt(c) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (parseInt(c) / 4)))).toString(16)
    );
  if (window.localStorage.uuid) {
    return window.localStorage.uuid;
  }
  window.localStorage.uuid = uuid4;
  return uuid4;
};

export const getScreen = (): boolean => {
  const qs = new URLSearchParams(window.location.search);
  const screenParam = qs.get('screen');
  const safeScreenParam = screenParam ? filterXSS(screenParam) : null;

  if (safeScreenParam) {
    const screenValue = safeScreenParam.toLowerCase();
    const isScreenRequested = screenValue === '1' || screenValue === 'true';

    const supportsScreenShare =
      typeof navigator !== 'undefined' &&
      (navigator.mediaDevices?.getDisplayMedia || (navigator as any).getDisplayMedia); // Fallback for older APIs

    return isScreenRequested && !!supportsScreenShare;
  }

  return false;
};

export const getMapKeyByValue = (map: Map<any, any>, searchValue: string) => {
  for (let [key, value] of map.entries()) {
    if (value === searchValue) return key;
  }
};
